import _ from "lodash";
import moment from "moment";
import locationData from "@/assets/location/location.json";

export const TARGET_MOMENT_TIMEZONE =
  process.env.TARGET_MOMENT_TIMEZONE || "Australia/Sydney";

// @Common
function convertAddressObject(address) {  
  // Convert address object to string
  let data = address;
  let dataArray = [];
  if (!address) return "";
  if (_.isArray(address)) {
    data = address[0];
  }
  if (data["street"]) dataArray.push(String(data["street"]).trim());
  if (data["city"]) dataArray.push(String(data["city"]).trim());
  if (data["state"]) dataArray.push(String(data["state"]).trim());
  if (data["postcode"]) dataArray.push(String(data["postcode"]).trim());
  if (data["country"]) dataArray.push(String(data["country"]).trim());

  return dataArray.join(", ");
}
function getStateSubInAddress(address) {
  if (!address) return;
  const addressArray = address.split(",");
  let addressRaw = { state: null, suburb: null };
  addressArray.forEach((line) => {
    line = line.trim();
    const foundLocation = _.find(locationData["data"], (loc) => {
      return loc.state == line || loc.suburb == line || loc.postcode == line;
    });

    if (!_.isEmpty(foundLocation)) {
      addressRaw.state = foundLocation["state_name"];
      addressRaw.suburb = foundLocation["suburb"];
    }
  });
  return addressRaw;
}

// Disable all fields from schema Object
function disableAllField(fields) {
  Object.keys(fields).forEach((i) => {
    if (!fields[i].children) {
      fields[i]["disabled"] = true;
    } else {
      fields[i].children = disableAllField(fields[i].children);
    }
  });
  return fields;
}

// Enable all fields from schema Object
function enableAllField(fields) {
  Object.keys(fields).forEach((i) => {
    if (!fields[i].children) {
      fields[i]["disabled"] = false;
    } else {
      fields[i].children = enableAllField(fields[i].children);
    }
  });
  return fields;
}

function formatValues(values) {
  Object.keys(values).forEach((i) => {
    if (moment(values[i]).isValid()) {
      values[i] = formatDate(values[i], "YYYY-MM-DD");
    }
  });
  return values;
}

function findRootUID(user) {
  if (!_.isEmpty(user.webProfiles)) {
    const rootProfile = _.find(user.webProfiles, { isRoot: true });
    return rootProfile ? rootProfile.uid : null;
  }
}

// Set all value to schema field Object
// function setSchemaValues(fields, values){
//     console.log('Q1--',fields, values);
//     Object.keys(fields).forEach(i => {
//         if(!fields[i].children){
//             console.log('Name--',fields[i]['name']);
//             //fields[i]['name'] = true;
//             // if(values[fields[i]['name']]){
//             //     fields[i]['value'] = values[fields[i]['name']]
//             // }
//         }else{
//             //console.log('Cv -- ',fields,values);
//             if(fields[i]['name']){
//                 //fields[i].children = setSchemaValues(values[fields[i]['name']])
//                 //console.log('C1--',fields[i].children,values[fields[i]['name']]);
//             }else{
//                 console.log('C2--',fields[i].children,values);
//                 fields[i].children = setSchemaValues(values)
//             }

//         }
//     });
//     console.log('p1--',fields, values);
//     return fields;
// }
//date format
const dateFormat = "DD/MM/YYYY HH:mm";
function formatDate(date, format = dateFormat, keepTimezoneOffset = false, convertToTargetTz = false) {
  if (keepTimezoneOffset) {
    date = moment.parseZone(date);
  }

  if (convertToTargetTz) {
    return moment(date).tz(TARGET_MOMENT_TIMEZONE).format(format);
  }
  return moment(date).format(format);
}

function formatCleanDate(date) {
  return moment(date).format("MMM DD, YYYY");
}

const filterRow = (keyword, attributeToFilter) =>
  keyword
    .toLowerCase()
    .split(" ")
    .every((v) => attributeToFilter.trim().toLowerCase().includes(v));

function ObjectToQueryString(object = {}) {
  var queryString = Object.keys(object)
    .map((key) => key + "=" + object[key])
    .join("&");
  return queryString;
}

function formatPaginationSettings(resultsMeta) {
  const paged = resultsMeta ? resultsMeta.skip / resultsMeta.limit + 1 : 1;
  return {
    page: paged ? paged : 1,
    totalPages: resultsMeta?.total
      ? Math.ceil(resultsMeta.total / resultsMeta.limit)
      : 1,
    totalRecords: resultsMeta?.total ? resultsMeta.total : 10,
    /* Setting the visiblePageItemCount to 5 by default to avoid overwhelming values
    visiblePageItemCount: resultsMeta?.count ? resultsMeta.count : 5,
    */
    visiblePageItemCount: resultsMeta?.count ? 5 : 1,
  };
}

function print(htmlElementId) {
  // Get HTML to print from element
  const insideDiv = document.getElementById(`${htmlElementId}`).innerHTML;

  let popupWinHeight = 650,
    popupWinWidth = 1200;

  // Set the window area
  var left = (screen.width - popupWinWidth) / 2;
  var top = (screen.width - popupWinHeight) / 6;

  // Get all stylesheets HTML
  let stylesHtml = "";
  for (const node of [
    ...document.querySelectorAll('link[rel="stylesheet"], style'),
  ]) {
    stylesHtml += node.outerHTML;
  }

  // Open the print window
  const winPrint = window.open(
    "data:text/html",
    "",
    "_blank",
    "resizable=yes, width=" +
      popupWinWidth +
      ", height=" +
      popupWinHeight +
      ", top=" +
      top +
      ", left=" +
      left
  );

  winPrint.document.write(`<!DOCTYPE html>
        <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${insideDiv}
            </body>
        </html>`);

  winPrint.document.close();
  setTimeout(() => {
    winPrint.print();
  }, 500);
  winPrint.onfocus = () => {
    setTimeout(() => {
      winPrint.close();
    }, 500);
  };
  return;
}

function removeStringHipen(string) {
  if (!string) return "";
  let str = string.replace(/-/g, " ");
  return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}

function removeStringUnderscore(string) {
  if (!string) return "";
  let str = string.replace(/_/g, " ");
  return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}

function cleanDateFormat(date, isShort = false, withTime = false) {
  let format = "MMM D, YYYY";
  format = withTime ? `${format} hh:mm A` : format;

  if (!date) return;
  if (isShort) return date ? moment(date).format(format) : "-";
  else return date ? moment(date).format(format) : "-";
}

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function isPilletOptionAvailable(option) {
  if (option) {
    option = String(option).toLowerCase();
    const dataOption = [
      "yes",
      "no",
      "pass",
      "passed",
      "fail",
      "failed",
      "true",
      "false",
    ];
    return dataOption.includes(option);
  }
  return false;
}

const roundValue = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

function findDepotById(id, rootArr) {
  for (const el of rootArr) {
    if (el._id === id) {
      return el;
    }
    if (el.children) {
      const idFoundInChildren = findDepotById(id, el.children);
      if (idFoundInChildren !== null) {
        return idFoundInChildren;
      }
    }
  }
  return null;
}
function getDepots(sites) {
  let children = [];
  const flattenDepots = sites.map((m) => {
    if (m.children && m.children.length) {
      children = [...children, ...m.children];
    }
    return m;
  });

  return flattenDepots.concat(children.length ? getDepots(children) : children);
}

function capitalizeFirstLetter(string) {
  if (!string) return "";
  string = string.replace('_', ' ').toLowerCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function viewFileUrl(url) {
  window.open(url, "_blank");
}

function convertJSONToCSV(data) {
  const array = typeof data !== 'object' ? JSON.parse(data) : data;
  let str = '';

  for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
          if (line !== '') line += ',';

          line += '"' + array[i][index].toString().replace(/"/g, '""') + '"';
      }

      str += line + '\r\n';
  }

  return str;
}
function downloadCSV(csvString, fileName) {
  const blob = new Blob([csvString], { type: 'text/csv' });
  const a = document.createElement('a');

  a.href = URL.createObjectURL(blob);
  a.download = `${fileName}.csv`;
  a.click();
}

export {
  findDepotById,
  getDepots,
  isPilletOptionAvailable,
  convertAddressObject,
  getStateSubInAddress,
  disableAllField,
  formatDate,
  formatCleanDate,
  formatValues,
  filterRow,
  findRootUID,
  ObjectToQueryString,
  formatPaginationSettings,
  roundValue,
  print,
  removeStringHipen,
  removeStringUnderscore,
  cleanDateFormat,
  validateEmail,
  capitalizeFirstLetter,
  enableAllField,
  viewFileUrl,
  convertJSONToCSV,
  downloadCSV
};
